<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row mb-2">
                    <h1 class="col-md-12 text-center">Locations</h1>
                </div>

                <div class="row  mt-2">

                    <div class="col-md-2 " v-if="authenticatedUser.permissions.includes('super') ">
                        <b-link class="" :to="{ path: '/location-form',query: { type: 'add'} }">
                            <b-button class="btn-info mb-2" > Add Location </b-button>
                        </b-link>
                    </div>

                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <b-input v-model="searchName"
                                 @input="debouncedSearch"
                                 placeholder="Search by Name"></b-input>
                    </div>

                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <v-select
                            v-model="statusFilter"
                            class="text-dark"
                            :options="statusOptions"
                            @input="onStatusChange"
                        />
                    </div>

                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="locations?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="locations?.to-50>0">{{locations?.to-50}}</span> <span v-else="">0</span>  to {{locations.to}}) out of {{locations.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="locations?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                 <div class="col-md-12">
                     <table class="table table-bordered table-striped text-light">
                         <thead class="thead-dark">
                         <tr>

                             <th>ID</th>
                             <th>Location Name</th>
                             <th>Short Code</th>
                             <th>Status</th>
                             <th>Description</th>
                             <th>Address 1</th>
                             <th>Post Code</th>
                             <th class="text-center">Actions</th>
                         </tr>
                         </thead>
                         <tbody >
                         <template v-for="location in locations.data">
                             <tr>
                                 <td>{{location.id}}</td>
                                 <td>{{location.location_name}}</td>
                                 <td>{{location.short_code}}</td>
                                 <td>{{ location.status == '1' ? 'Active' : 'Inactive' }}</td>
                                 <td>{{location.location_description}}</td>
                                 <td>{{location.address_1}}</td>
                                 <td>{{location.post_code}}</td>
                                 <td class="text-center">
                                     <b-link class="mx-1" :to="{ path: '/location-form',query: { type: 'edit', 'id': location.id } }">
                                         <b-button class="btn-info  mb-1" > Edit </b-button>
                                     </b-link>
<!--                                     <b-button @click="deleteLocation(location.id)" :disabled="saving" class="btn-danger "> Delete </b-button>-->
                                 </td>
                             </tr>
                         </template>

                         </tbody>
                     </table>
                 </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from "lodash";
import debounce from "lodash/debounce";
import vSelect from "vue-select";


export default {
    name: "location management",

    components:{Loader, Welcomenote, 'v-select': vSelect, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('locations',['location_filters','locations']),
        totalPages() {
            const perpage = this.locations.per_page;
            const total=this.locations.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,
            showloader:false,
            searchName:'',
            statusFilter: { value: '1', label: 'Active' },
            statusOptions: [
                { value: '1', label: 'Active' },
                { value: '0', label: 'Inactive' },
                { value: '', label: 'All' },
            ],
        };
    },
    async created() {
        this.searchName = this.location_filters.location_name;
        this.showloader=true
        await this.get_locations();
        this.showloader=false

    },
    async mounted() {

    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('locations', ['set_locations','get_locations']),

        debouncedSearch: debounce(function () {
            this.location_filters.location_name = this.searchName;
            this.location_filters.page = 1;
            this.showloader = true;
            this.get_locations().finally(() => {
                this.showloader = false;
            });
        }, 500),

        async deleteLocation(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to delete this location?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.delete(`${URL.BASEURL}/api/delete-location/${id}`);

                    if (res) {
                        let locations=cloneDeep(this.locations)
                        locations.data=this.locations.data.filter((c)=>c.id!==id)
                        await this.set_locations(locations)

                        Swal.fire('success', 'Location Deleted', 'success');

                    } else {
                        Swal.fire('info', 'Location Cannot Be Deleted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to delete location.', 'info');
                }
                this.saving=false
            }

        },

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        onStatusChange() {
            this.location_filters.status = this.statusFilter.value;
            this.location_filters.page = 1;
            this.showloader = true;
            this.get_locations().finally(() => {
                this.showloader = false;
            });
        },

        async get_paged_data(button){
            let current_page= this.locations.current_page
            this.location_filters.page=current_page

            if(button=='next'){
                this.location_filters.page=current_page+1
                await this.get_locations()
            }
            if(button=='prev'){
                this.location_filters.page=current_page-1
                await this.get_locations()
            }
        },

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
